// Mention wire format: <@uuid> tokens in the body + a mentions[] array.

/** Turns "@Display Name" chips back into <@uuid> tokens for the wire format. */
export function encodeMentions(text: string, picked: Map<string, string>) {
  let body = text;
  const ids = new Set<string>();
  for (const [name, id] of [...picked.entries()].sort((a, b) => b[0].length - a[0].length)) {
    if (body.includes(`@${name}`)) {
      body = body.split(`@${name}`).join(`<@${id}>`);
      ids.add(id);
    }
  }
  return { body, mentions: [...ids] };
}

/** Inverse of encodeMentions for editing an existing message. */
export function decodeMentions(body: string, nameOf: (id: string) => string) {
  const picked = new Map<string, string>();
  const text = body.replace(/<@([0-9a-f-]{36})>/g, (_, id: string) => { const n = nameOf(id); picked.set(n, id); return `@${n}`; });
  return { text, picked };
}

/** @-mention suggestions: active people matching the text after @, never yourself, at most 8. */
export function mentionCandidates<M extends { user_id: string; display_name: string; status?: string }>(pool: M[], query: string, selfId: string | null | undefined): M[] {
  const q = query.toLowerCase();
  return pool.filter(m => (m.status ?? 'active') === 'active' && m.user_id !== selfId && m.display_name.toLowerCase().includes(q)).slice(0, 8);
}
